export class UsersRole {
  constructor(
    public name: string,
    public slug: string,
    public disabled: boolean
  ) {}
}
